import { HugeiconsIcon } from '@hugeicons/react'

import { cn } from '@/lib/utils'

import { type Tom, tons } from '@/components/heimdall/tons'

type IconeTomProps = {
  icone: Parameters<typeof HugeiconsIcon>[0]['icon']
  tom: Tom
  tamanho?: 'sm' | 'md' | 'lg'
  className?: string
}

const tamanhos = {
  sm: 'size-8 [&_svg]:size-4',
  md: 'size-10 [&_svg]:size-5',
  lg: 'size-12 [&_svg]:size-6',
}

/** Ícone dentro de um círculo tingido com a cor da área. */
export function IconeTom({ icone, tom, tamanho = 'md', className }: IconeTomProps) {
  return (
    <span
      aria-hidden
      className={cn(
        'flex shrink-0 items-center justify-center rounded-full',
        tons[tom],
        tamanhos[tamanho],
        className
      )}
    >
      <HugeiconsIcon icon={icone} strokeWidth={2} />
    </span>
  )
}
